  (function () {
    // Category selector navigation
    var select = document.getElementById('mnlGuideCategory');
    var go = document.querySelector('[data-mnl-guide-go]');
    if (select && go) {
      go.addEventListener('click', function () {
        var url = select.value;
        if (url) window.location.href = url;
      });
      select.addEventListener('change', function () {
        // Optional: auto navigate on select change
        // if (select.value) window.location.href = select.value;
      });
    }

    // Obfuscated links (base64 -> URL)
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.mnl-obf');
      if (!a) return;
      e.preventDefault();
      try {
        var url = atob(a.dataset.u || '');
        if (url) window.location.href = url;
      } catch (err) {}
    });
  })();
